import React from 'react';
import NumberFormat from 'react-number-format';
import {IEvent} from "../../interfaces/IEvent";


interface Props {
    value: number | undefined
    name: string
    precision?: number
    onChange: (event: IEvent) => void | null
    prefix?: string
    suffix?: string
    label?: string
}

const NumberField = (props: Props) => {
    const {value, name, precision, prefix = "", onChange, ...inputProps} = props;

    const decimalScale = precision != null ? precision : 2;

    const handleChange = (values) => {
        onChange({target: {name: name, value: values.floatValue}})
    };

    return (<>
        <NumberFormat
            thousandSeparator
            allowNegative={false}
            decimalScale={decimalScale}
            prefix={prefix}
            sufix={inputProps.suffix}
            value={value}
            onValueChange={handleChange}
            {...inputProps}
        />
    </>);
};

export default NumberField;
